<template>
  <div class="location">

    <div class="edit-area" :style="mapHeight">
      <h1 class="normal">土拍记录</h1>

      <div class="normal">
        是否火热：
        <el-radio v-model="oneDeal.hot" :label="1">是</el-radio>
        <el-radio v-model="oneDeal.hot" :label="0">否</el-radio>
      </div>
      <div class="normal">
        <input type="text" placeholder="测绘坐标转换" @keydown.enter="formatLnglat">
      </div>
      <div class="normal" v-if="oneDeal.lnglat">经纬度：{{oneDeal.lnglat}}</div>
      <div class="normal">宗地位置：
        <div class="inputBox">
          <el-input v-model="oneDeal.location"></el-input>
        </div>
      </div>
      <div class="normal">楼面价(元/m²)：
        <div class="inputBox">
          <el-input v-model="oneDeal.floor_price"></el-input>
        </div>
      </div>
      <div class="normal">竞得方：
        <div class="inputBox">
          <el-input v-model="oneDeal.owner"></el-input>
        </div>
      </div>
      <div class="normal">开发商：
        <div class="inputBox">
          <el-input v-model="oneDeal.develop"></el-input>
        </div>
      </div>
      <div class="normal">起拍价(万元)：
        <div class="inputBox">
          <el-input v-model="oneDeal.base_price"></el-input>
        </div>
      </div>
      <div class="normal">成交价(万元)：
        <div class="inputBox">
          <el-input v-model="oneDeal.deal_price"></el-input>
        </div>
      </div>
      <div class="normal">土地面积(m²)：
        <div class="inputBox">
          <el-input v-model="oneDeal.square"></el-input>
        </div>
      </div>
      <div class="normal">建筑面积(m²)：
        <div class="inputBox">
          <el-input v-model="oneDeal.squareJ"></el-input>
        </div>
      </div>
      <div class="normal">住宅面积(m²)：
        <div class="inputBox">
          <el-input v-model="oneDeal.squareZ"></el-input>
        </div>
      </div>
      <div class="normal">商业面积(m²)：
        <div class="inputBox">
          <el-input v-model="oneDeal.squareS"></el-input>
        </div>
      </div>
      <div class="normal">自持率：
        <div class="inputBox">
          <el-input v-model="oneDeal.hold"></el-input>
        </div>
      </div>
      <div class="normal">最大容积率：
        <div class="inputBox">
          <el-input v-model="oneDeal.capacity"></el-input>
        </div>
      </div>
      <div class="normal">溢价率：
        <div class="inputBox">
          <el-input v-model="oneDeal.premium"></el-input>
        </div>
      </div>
      <div class="normal">土地用途：
        <div class="inputBox">
          <el-input v-model="oneDeal.purpose"></el-input>
        </div>
      </div>
      <div class="normal">出让年限：
        <div class="inputBox">
          <el-input v-model="oneDeal.term"></el-input>
        </div>
      </div>
      <div class="normal">地块编号：
        <div class="inputBox">
          <el-input v-model="oneDeal.number"></el-input>
        </div>
      </div>
      <div class="normal">地块名称：
        <div class="inputBox">
          <el-input v-model="oneDeal.name"></el-input>
        </div>
      </div>
      <div class="normal">成交日期：
        <div class="inputBox">
          <el-input v-model="oneDeal.deal_date"></el-input>
        </div>
      </div>
      <div class="normal">精装限价(元/m²)：
        <div class="inputBox">
          <el-input v-model="oneDeal.limitj"></el-input>
        </div>
      </div>
      <div class="normal">毛坯限价(元/m²)：
        <div class="inputBox">
          <el-input v-model="oneDeal.limitm"></el-input>
        </div>
      </div>
      <div class="normal">绑定楼盘：
        <el-select v-model="oneDeal.estate_id" filterable placeholder="选择楼盘" default-first-option
            :remote-method="searchEstate" remote clearable>
          <el-option v-for="(item,index) in matchEstates" :key="index" :label="item.real_estate_name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="normal">待出让：
        <el-radio v-model="oneDeal.wait" :label="true">是</el-radio>
        <el-radio v-model="oneDeal.wait" :label="false">否</el-radio>
      </div>
      <div class="normal">已终止：
        <el-radio v-model="oneDeal.discontinue" :label="1">是</el-radio>
        <el-radio v-model="oneDeal.discontinue" :label="0">否</el-radio>
      </div>
      <div class="normal">竞拍次数：
        <div class="inputBox">
          <el-input v-model="oneDeal.auctions_times" type="number"></el-input>
        </div>
      </div>
      <div class="normal">
        <el-button type="primary" @click="upToDb()">保存</el-button>
      </div>
      <div class="normal">
        <el-button type="warning" @click="upToDb(true)">保存并新建楼盘</el-button>
      </div>

    </div>

    <div id="location_map" :style="mapHeight">
      <el-amap-search-box class="search-box" :search-option="searchOption" :on-search-result="onSearchResult">
      </el-amap-search-box>
      <el-amap class="amap-box" vid="real_map" ref="real_map" :zoom="zoom" :center="center" :amap-manager="amapManager"
        :plugin="plugin" :events="events">
        <el-amap-marker :vid="'search_marker' + index" v-for="(marker,index) in markers" :key="'search_marker' + index"
          :position="[marker.lng,marker.lat]">
        </el-amap-marker>

        <el-amap-marker vid="lnglat_marker" v-if="oneDeal.lnglat" :position="oneDeal.lnglat.split('|')"
          icon="./../../static/images/marker.png"  :events="markerEvents">
        </el-amap-marker>

        <el-amap-polyline
          :path="boundary"
          borderWeight= 2
          strokeColor= 'red'
        >
        </el-amap-polyline>

          <el-amap-marker :draggable="true" v-for="(item,index) of boundary" :vid="index" :key="index+'555555'"  :position="item.lat?[item.lng,item.lat]:item"
            :events="boundMarkerEvents">
        </el-amap-marker>
      </el-amap>
    </div>

  </div>
</template>

<script>
  import {
    AMapManager
  } from "vue-amap"
  let amapManager = new AMapManager();
  export default {
    data() {
      return {
        oneDeal: {},
        needMap: {
            lnglat: '经纬度', 
            district: '地块区域',     
            location: '宗地位置',     
            owner: '竞得方',      
            develop: '开发商',
            floor_price: '楼面价',
            base_price: '起拍价',
            deal_price: '成交价',
            square: '出让面积', 
            capacity: '容积率', 
            premium: '溢价率',  
            purpose: '土地用途',
            term: '出让年限',  
            number: '宗地编号',
            deal_date: '成交日期',
        },
        boundary:[],
        mapHeight: {}, // 地图高度
        zoom: 15, // 地图缩放级别
        center: [120.051238, 30.228232], // 地图中心点
        amapManager, // 地图管理对象
        plugin: [{ //地图类型，卫星地图和普通地图
          pName: 'MapType',
          defaultType: 0,
        }],
        searchOption: { // 搜索配置
          city: '杭州',
          citylimit: true
        },
        events: { // 地图事件
          'click':(e)=>{
            if(this.boundary[0]==this.boundary[this.boundary.length-1]&&this.boundary.length>3){
              this.boundary.pop()
            }
            this.boundary.push([e.lnglat.lng ,e.lnglat.lat])
            if(this.boundary.length>3){
              this.boundary.push(this.boundary[0])
            }
          },
          'rightclick': (e) => {
            console.log('点击地图')
            let that = this;
            let obj = JSON.parse(JSON.stringify(that.oneDeal));
            obj.lnglat = e.lnglat.lng + '|' + e.lnglat.lat;
            that.oneDeal = obj;
            console.log('that.oneDeal.lnglat',that.boundary, that.oneDeal.lnglat);
          }
        },
        markerEvents: { // 当前新增或修改的地段的坐标点的事件, 右击删除
          'click':(e)=>{
            if(this.boundary.length!=0)this.boundary = []
          },
          'rightclick': (e) => {
            console.log('点击经纬度坐标')
            let that = this
            let obj = JSON.parse(JSON.stringify(that.oneDeal));
            delete obj.lnglat;
            that.oneDeal = obj;
          }
        },
        boundMarkerEvents: { // 当前新增或修改的地段的坐标点的事件, 右击删除
          'rightclick': (e) => {
            console.log('点击经纬度坐标')
            this.boundary.splice( e.target.w.vid,1)
          },
          'dragging':(e)=>{
            console.log('jjjjjjjjj')
            this.boundary.splice( e.target.w.vid,1,[e.lnglat.lng ,e.lnglat.lat])
          }
        },
        markers: [], // 搜索结果坐标点

        matchEstates: [],

        areaList: [],
        districts: [],
        landDbMap: {
          '杭州': 'LandDealModel',
          '苏州': 'SzLandDealModel',
        }
      }
    },
    created() {
      let height = window.innerHeight + 'px';
      console.log(height)
      this.mapHeight.height = height
    },
    beforeRouteEnter(to, from, next) {
      if(from.name === 'login') {
        to.meta.isBack = true;
      }
      next();
    },
    activated() {
      if(!this.$route.meta.isBack){
        let origin = this.$options.data();
        delete origin.mapHeight;
        delete origin.events;
        delete origin.markerEvents;
        delete origin.boundMarkerEvents;
        Object.assign(this.$data, origin)
        this.init();
      }
      this.$route.meta.isBack=false
    },
    methods: {
      //地图搜索的回调
      onSearchResult(pois) {
        if (pois.length > 0) {
          let {
            lng,
            lat
          } = pois[0];
          this.markers = pois;
          this.center = [lng, lat];
        }
      },

      init() {
          let that = this;
          let obj = that.$route.params;
          const AreaMap = {
            '杭州': 'WpAreaModel',
            '苏州': 'SzAreaModel',
          }
          that.$axios.get(that.$url_prefix + 'getDB', {
            params: {
              dataContent: AreaMap[that.$store.state.Counter.city],
              projection: '-_id id area_name dots level'
            }
          }).then(function (res) {
            console.log('所有板块', res)
            that.areaList = res.data.data.filter(x => x.level === '板块');
            that.districts = res.data.data.filter(x => x.level === '区域');
          })
          if (obj.id) {
            that.$axios.get(that.$url_prefix + 'queryOneById', {
              params: {
                id: obj.id,
                db: that.landDbMap[that.$store.state.Counter.city]
              }
            }).then(function (res) {
              let oneDeal = res.data.data;
              oneDeal.hot = oneDeal.hot || 0;
              that.oneDeal = oneDeal;
              console.log('oneDeal', oneDeal);
              if (oneDeal.lnglat) {
                that.center = oneDeal.lnglat.split('|');
              }
              if (oneDeal.realEstate) {
                that.matchEstates.push(oneDeal.realEstate);
                delete oneDeal.realEstate;
              }
              if(oneDeal.boundary){
                that.boundary = (JSON.parse(oneDeal.boundary))[0].map((item)=>{
                  if(item.lat)return [item.lng,item.lat]
                  else return item
                })
              }
            }).catch(function (res) {
              console.log('query fail', res);
              that.$message.error('查询失败, 请检查网络');
            })
          }
      },

      //上传数据库
      async upToDb(toReal) {
        let that = this;
        
        if (!that.oneDeal.number) {
          that.$message.error('没有地块编号');
          return;
        }

        that.oneDeal.number = that.oneDeal.number.replace(/\s/g, '')
        .replace('【','[')
        .replace('】', ']')
        .replace('〔','[')
        .replace('〕', ']')
        .replace('（','[')
        .replace('）', ']')
        .replace('(','[')
        .replace(')', ']');

        if (!that.oneDeal.squareJ) { // 没有建筑面积，看能不能计算
          if (that.oneDeal.square && that.oneDeal.capacity) {
            let temps = (parseFloat(that.oneDeal.capacity) * parseFloat(that.oneDeal.square)).toFixed(1);
            if (temps) {
              that.oneDeal.squareJ = temps;
            }
          }
        }

        // 计算楼面价
        if (!that.oneDeal.floor_price) {
          if (that.oneDeal.squareJ && that.oneDeal.deal_price) {
            let temps = Math.round(parseFloat(that.oneDeal.deal_price) * 10000 / parseFloat(that.oneDeal.squareJ));
            if (temps) {
              that.oneDeal.floor_price = temps;
            }
          }
        }

        that.oneDeal.deal_date = that.oneDeal.deal_date || '暂无';

        if (that.oneDeal.lnglat) {
          let dot = that.oneDeal.lnglat.split('|')
          let result = that.judgeArea(dot)
          if (result) {
            that.oneDeal.area_id = result.id
            that.oneDeal.area_name = result.area_name
          }
          let resultD = that.judgeDistrict(dot);
          if (resultD) {
            that.oneDeal.district = resultD.area_name;
          }
        }
          that.oneDeal.boundary = JSON.stringify([that.boundary.map((item)=>{
                  if(item.lat)return [item.lng,item.lat]
                  else return item
                })])

        try { //更改终止状态(不同接口)
          let temp = {
            id: this.oneDeal.id,
            discontinue: this.oneDeal.discontinue
          } 
          await this.$axios.post(this.$url_prefix + 'data/landdeal/discontinue', temp)
          this.$message({
            type: 'success',
            message: '成功'
          })
        } catch(err) {
          console.log("🚀 ~ file: IndexPage.vue:2008 ~ landdealStop ~ err:", err)
          this.$message.error('失败');
        }
        
        let param = {
          'db': that.landDbMap[that.$store.state.Counter.city],
          'model': 'edit',
          'item': JSON.stringify(that.oneDeal),
          'toReal': toReal
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (want) {
          console.log('update back', want);
          that.$router.push({
            path: '/IndexPage'
          })
        }).catch(function (res) {
          console.log('update fail', res);
        })
      },

      searchEstate(search) {
        let that = this;
        if (search) {
          that.$axios.get(that.$url_prefix + 'searchEstateName', {
            params: {
              search: search
            }
          }).then(res => {
            that.matchEstates = res.data.data;
          })
        }
      },

      // 判断楼盘 属于哪个板块
      judgeArea(pos) {
        let that = this
        for (let k = 0; k < that.areaList.length; k++) {
          if (that.areaList[k].dots) {
            let temp = that.areaList[k].dots.split('-').map(x => x.split('|'))
            if (AMap.GeometryUtil.isPointInRing(pos, temp)) {
              return that.areaList[k]
            }
          }
        }
        return false
      },
      // 判断楼盘 属于哪个区
      judgeDistrict(pos) {
        let that = this
        for (let k = 0; k < that.districts.length; k++) {
          if (that.districts[k].dots) {
            let temp = that.districts[k].dots.split('-').map(x => x.split('|'))
            if (AMap.GeometryUtil.isPointInRing(pos, temp)) {
              return that.districts[k]
            }
          }
        }
        return false
      },

      // 所有土拍
      allLand() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'getDB', {
          params: {
            dataContent: that.landDbMap[that.$store.state.Counter.city],
            projection: '-_id id lnglat'
          }
        }).then(function (res) {
          console.log('所有土拍', res)
          that.landCircle(res.data.data.filter(x => x.lnglat));
        })
      },
      landCircle(list) {
        let that = this;
        if (list.length === 0) {
          console.log('over');
          return;
        }
        let one = list.splice(0,1)[0];

        let dot = one.lnglat.split('|')
        let result = that.judgeArea(dot)
        if (result) {
          one.area_name = result.area_name
          one.area_id = result.id
        }
        let resultD = that.judgeDistrict(dot);
        if (resultD) {
          one.district = resultD.area_name;
        }

        let param = {
          'db': that.landDbMap[that.$store.state.Counter.city],
          'model': 'edit',
          'item': JSON.stringify(one)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (want) {
          that.landCircle(list);
        }).catch(function (res) {
          console.log('update fail', res);
          that.landCircle(list);
        })
      },

      formatLnglat(e) {
        let that = this;
        let value = e.target.value.trim().replace('，',',');
        if (value && value.includes(',')) {
          let arr = value.split(',');
          let X = parseFloat(arr[0]);
          let Y = parseFloat(arr[1]);

          let x,y,B,L;
          let L0 = 120;
          let p = 206264.80625;
          for (let i = 1; Y/i >=10; i = i * 10) {
            y = Y - parseInt(Y / i) * i-500000;
          }

          x = X;
          let bt = x / 6367558.4969*p;
          let BT = x / 6367558.4969;
          let c3=Math.cos(BT)*Math.cos(BT);
          let c4=Math.sin(BT)*Math.cos(BT);
          let Bf=(bt+(50221746+(293622+(2350+22*c3)*c3)*c3)*c4*Math.pow(10,-10)*p)/p;
          let c5=Math.pow(Math.cos(Bf),2);
          let c6=Math.sin(Bf)*Math.cos(Bf);
          let Nf=6399698.902-(21562.267-(108.973-0.612*c5)*c5)*c5;
          let Z=y/(Nf*Math.cos(Bf));
          let b2 = (0.5 + 0.003369 * c5) * c6;
          let b3 = 0.333333 - (0.166667 - 0.001123 * c5) * c5;
          let b4 = 0.25 + (0.16161 + 0.00562 * c5) * c5;
          let b5=0.2-(0.1667-0.0088*c5)*c5;
          let z2=Math.pow(Z,2);
          B = (Bf*p - (1 - (b4 - 0.12 *z2) * z2) * z2 * b2 * p)/3600.0;
          L = L0+((1 - (b3 - b5 * z2) * z2) * Z * p)/3600.0;
          AMap.convertFrom([L,B], 'gps', function (status, result) {
            console.log('result',result);
            if (result.info == 'ok') {
              let loc = result.locations[0];
              that.oneDeal.lnglat = loc.lng + '|' + loc.lat;
              that.center = [loc.lng, loc.lat];
              that.$message({
                type: 'success',
                message: '转换成功'
              })
            } else {
              that.$message.error('转换失败');
            }
          });
        } else {
          that.$message.error('输入有误');
        }
      }

    }
  }

</script>

<style scoped>
  .location {
    display: flex;
  }

  .location .edit-area {
    width: 40%;
    overflow-y: auto;
    text-align: center;
  }

  .location #location_map {
    width: 60%;
    position: relative;
  }

  #location_map .search-box {
    position: absolute;
    left: 0;
    top: 0;
    border: 1px solid black;
  }

  .inputBox {
    display: inline-block;
    width: 50%;
  }

  .text {
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }

</style>



// WEBPACK FOOTER //
// src/page/LandDeal.vue